import { Injectable} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PlatformLocation } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { i18nPipe } from "../helper/i18n.pipes";
import * as $ from 'jquery';
import * as CryptoJS from 'crypto-js';
// import { BaseResponse } from "../model/ifcapp.models";

@Injectable()
export class BaseService {

    protected encryptIFCSecretKey = CryptoJS.enc.Utf8.parse("678dtECYiSfssS67");
    protected encryptIFCIV = CryptoJS.enc.Utf8.parse("tsDASJEUfd6fdqw1");
    protected sha1SecretKey = "chinetekifclms";


    headers: HttpHeaders;
    token = "";
    constructor(
        public http: HttpClient,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public platformLocation: PlatformLocation,
        public meta:Meta,
        public title:Title,
        public i18nPipe:i18nPipe
    ) {

    }

    setApiHeader(token) {
        this.headers = new HttpHeaders().set('Authorization',token);
        //headers.append('Authorization', token);
        //this.headers = headers;
        this.token = token;

        console.log("API headers:" + this.headers.get('Authorization'));
    }

    setIFCApiHeader(lang, platform , memberid, affiliated_card_id, session_key, deviceid) {
    // setIFCApiHeader(memberid) {
            this.headers = new HttpHeaders({
            'lang': lang,
            'platform': platform,
            'memberid': memberid,
            'affiliatecardid':affiliated_card_id,
            'sessionkey': session_key,
            'deviceid': deviceid
        });
        console.log("API headers:" + this.headers.get('lang'));
        console.log("API headers:" + this.headers.get('platform'));
        console.log("API headers:" + this.headers.get('memberid'));
        console.log("API headers:" + this.headers.get('sessionkey'));
        console.log("API headers:" + this.headers.get('deviceid'));
        console.log("API headers:" + this.headers.get('affiliatecardid'));
    }

    getICRewardDecryptData(d) {
        let bytes;
        if(d != null){
            bytes = CryptoJS.AES.decrypt(d, this.encryptIFCSecretKey, {
                iv: this.encryptIFCIV,
            });
        }
        if(bytes != null) {
            return bytes.toString(CryptoJS.enc.Utf8)
        }
        return false;
    }

    encryptICRewardData(d) {
        let encryptedData = CryptoJS.AES.encrypt(d, this.encryptIFCSecretKey, {
            iv: this.encryptIFCIV,
        }).toString();
        return encryptedData;
    }

    hashICRewardData(d) {
        let hashData = CryptoJS.SHA1(d + this.sha1SecretKey).toString();
        return hashData;
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    getCurrentUrl() {
        // var currentPath = "";
        var currentUrl = (this.platformLocation as any).location.origin + (this.platformLocation as any).pathname;

        console.log(currentUrl);


        return currentUrl;
    }


    getBaseUrl() {
        var baseUrl = "";
        baseUrl = (this.platformLocation as any).location.origin;

        return baseUrl;
    }
}